import { IRootState } from '@/store';
import { ActionTree } from 'vuex';
import { IAdministrationState } from './state';

import {
    LOADING_ARTIKEL,
    LOADING_TEILNEHMER,
    OFFSET_ARTIKEL,
    OFFSET_TEILNEHMER,
    TOTAL_NUMBER_OF_RECORDS_ARTIKEL,
    TOTAL_NUMBER_OF_RECORDS_TEILNEHMER,
    MAPARTIKEL,
    ADDARTIKEL,
    MAP_VETDATA_LOG,
    ADD_TEILNEHMERLIST,
    MAP_TEILNEHMERLIST,
    LOADING_BENUTZER,
    MAPBENUTZERDATA,
    MAP_LIEFERANT_DETAILS_DATA,
    TOTAL_NUMBER_OF_RECORDS_LIEFERANTEN_DOKUMENTE,
    MAP_LIEFERANTEN_DOKUMENTE,
    ADD_LIEFERANTEN_DOKUMENTE,
    OFFSET_DOKUMENTE,
    LOADING_DOKUMENTE,
    LOADING_FEHLERHAFTE_RECHNUNGEN_ADMIN,
    OFFSET_FEHLERHAFTE_RECHNUNGEN_ADMIN,
    TOTAL_NUMBER_OF_RECORDS_FEHLERHAFTE_RECHNUNGEN_ADMIN,
    MAP_FEHLERHAFTE_RECHNUNGEN_ADMIN,
    ADD_FEHLERHAFTE_RECHNUNGEN_ADMIN,
    MAP_LIEFERANTEN_FOR_FILTER
} from './mutations';
import { NAME } from './';

import { takeTeilnehmerService } from '../services/TakeTeilnehmerService';
import { adminUploadService } from '../services/AdminUploadService';
import { benutzerinfoService } from '../services/BenutzerinfoService';
import { CLOSE, NEW_ERRORMESSAGES, NEW_INFO, NEW_SUCESS } from '@/store/modules/headerNotification/actions';
import { GET_PERMISSIONS, GET_BENUTZERINFO } from '@/store/modules/security/actions';
import { SHOW, HIDE } from '@/store/modules/loadingSpinner/actions';
import { TakeTeilnehmerApiDto } from '@/api-schema';
import { TeilnehmerFilterDto } from '@/types/TeilnehmerFilterDto';
import { downloadService } from '@/services/downloadService';
import { BenutzerInfoSearchApiDto } from '@/types/BenutzerInfoSearchApiDto';
import { $router } from '@/main';
import { LieferantDokumentUploadDto } from '@/types/LieferantDokumentUploadDto';
import { i18n } from '@/plugins/i18n';
import { lieferantenDokumentArchivService } from '@/areas/administration/services/LieferantenDokumentArchivService';
import { securityService } from '@/services/securityService';
import { rechnungService } from '@/services/rechnungService';
import { MAPBENUTZERDETAILS } from '@/areas/kunde/profileinstellungen/store/mutations';

export const TAKESPECIFIC = 'TakeSpecific';
export const RESET = 'Reset';
export const GET_TEILNEHMER = 'GetTeilnehmer';
export const GET_NEXT_TEILNEHMER = 'GetNextTeilnehmer';
export const GET_ARTIKEL = 'GetArtikel';
export const GET_VETDATA_LOG = 'GetVetdataLog';
export const START_VETPOINT_IMPORT = 'startVetpointImport';
export const DOWNLOAD_TEILNEHMER = 'DownloadTeilnehmer';
export const GET_BENUTZER = 'GetBenutzer';
export const LOAD_LIEFERANT_DETAILS = 'loadLieferantDetails';
export const UPLOAD_DOKUMENT = 'uploadDokument';
export const CLEAR_LIEFERANT_DETAILS = 'clearLieferantDetails';
export const LOAD_LIEFERANTEN_DOKUMENTE = 'loadLieferantenDokumente';
export const DELETE_DOKUMENT = 'deleteDokument';
export const OPEN_DOKUMENT = 'openDokument';
export const DOWNLOAD_DOKUMENT = 'downloadDokument';
export const GET_ALL_FEHLERHAFTE_RECHNUNGEN_ADMIN = 'getAllFehlerhafteRechnungenAdmin';
export const DELETE_FEHLERHAFTE_RECHNUNG_ADMIN = 'deleteFehlerhafteRechnungAdmin';
export const RETRY_RECHNUNG_PROCESSING_ADMIN = 'retryRechnungProcessingAdmin';
export const UPLOAD_FEHLERHAFTE_RECHNUNG_DATEI_ADMIN = 'uploadFehlerhafteRechnungDateiAdmin';
export const DOWNLOAD_BELEG_ADMIN = 'downloadBelegPdfAdmin';
export const OPEN_DOKUMENT_ADMIN = 'openDokumentAdmin';
export const LOAD_LIEFERANTEN = 'loadLieferanten';
export const GET_BENUTZER_DETAILS = 'getBenutzerDetails';

export const actions: ActionTree<IAdministrationState, IRootState> = {
    async [TAKESPECIFIC]({ dispatch }: any, teilnehmer: TakeTeilnehmerApiDto) {
        console.debug(NAME + '::' + TAKESPECIFIC);

        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        await takeTeilnehmerService.takeSpecific(teilnehmer).then(async () => {
            //Reload Permissions
            await dispatch('security/' + GET_PERMISSIONS, {}, { root: true });
            console.log('permissions loaded after setting specific user');
            await dispatch('security/' + GET_BENUTZERINFO, {}, { root: true });
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            dispatch(
                'headerNotification/' + NEW_SUCESS,
                {
                    text:
                        'Rolle wurde erfolgreich gewechselt mit TeilnehmerId: ' +
                        teilnehmer.teilnehmerId +
                        ' bzw. tvsKundennummer: ' +
                        teilnehmer.tvsKundennummer +
                        ' und Rolle: ' +
                        teilnehmer.benutzerRolle
                },
                { root: true }
            );
        });
    },

    async [RESET]({ dispatch }: any) {
        console.debug(NAME + '::' + RESET);

        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        await securityService.resetContext().then(async () => {
            //Reload Permissions
            await dispatch('security/' + GET_PERMISSIONS, {}, { root: true });
            await dispatch('security/' + GET_BENUTZERINFO, {}, { root: true });
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            dispatch('headerNotification/' + NEW_SUCESS, { text: 'Rolle erfolgreich zurückgesetzt' }, { root: true });
        });
    },

    async [GET_NEXT_TEILNEHMER]({ commit, state }: any) {
        console.debug(NAME + '::' + GET_NEXT_TEILNEHMER);

        if (state.teilnehmerLoading || (state.teilnehmerFilter.offset !== 0 && state.teilnehmerFilter.offset >= state.teilnehmerTotalNumberOfRecords)) {
            return;
        }

        commit(LOADING_TEILNEHMER, true);
        commit(OFFSET_TEILNEHMER, state.teilnehmerList.length);

        await takeTeilnehmerService.getTeilnehmer(state.teilnehmerFilter).then((response) => {
            commit(TOTAL_NUMBER_OF_RECORDS_TEILNEHMER, response.totalNumberOfRecords);
            commit(ADD_TEILNEHMERLIST, response.entries);
            commit(LOADING_TEILNEHMER, false);
        });
    },
    async [GET_TEILNEHMER]({ commit, state }: any) {
        console.debug(NAME + '::' + GET_TEILNEHMER);

        if (state.teilnehmerLoading || (state.teilnehmerFilter.offset !== 0 && state.teilnehmerFilter.offset >= state.teilnehmerTotalNumberOfRecords)) {
            return;
        }

        commit(LOADING_TEILNEHMER, true);
        commit(OFFSET_TEILNEHMER, 0);

        await takeTeilnehmerService.getTeilnehmer(state.teilnehmerFilter).then((response) => {
            commit(TOTAL_NUMBER_OF_RECORDS_TEILNEHMER, response.totalNumberOfRecords);
            commit(MAP_TEILNEHMERLIST, response.entries);
            commit(LOADING_TEILNEHMER, false);
        });
    },
    async [DOWNLOAD_TEILNEHMER]({ dispatch, commit, state }: any) {
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });

        //Lokale Kopie damit der State unverändert bleibt
        const filter: TeilnehmerFilterDto = JSON.parse(JSON.stringify(state.teilnehmerFilter));
        filter.offset = 0;
        filter.entriesToLoad = null;

        await takeTeilnehmerService.downloadTeilnehmer(filter).then((response) => {
            downloadService.downloadFile(response, 'export.csv');
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
        });
    },

    async [GET_ARTIKEL]({ commit, state }: any, offset: number) {
        console.debug(NAME + '::' + GET_ARTIKEL, offset);

        if (state.artikelLoading || (offset !== 0 && offset >= state.artikelTotalNumberOfRecords)) {
            return;
        }

        commit(LOADING_ARTIKEL, true);
        commit(OFFSET_ARTIKEL, offset);

        const searchQuery = Object.assign({}, state.artikelQueryFilter);

        await takeTeilnehmerService.getArtikel(searchQuery).then((response) => {
            if (!offset || offset < 1) {
                commit(TOTAL_NUMBER_OF_RECORDS_ARTIKEL, response.totalNumberOfRecords);
                commit(MAPARTIKEL, response.entries);
            } else {
                commit(ADDARTIKEL, response.entries);
            }
            commit(LOADING_ARTIKEL, false);
        });
    },
    async [GET_VETDATA_LOG]({ commit }: any) {
        console.debug(NAME + '::' + GET_VETDATA_LOG);

        takeTeilnehmerService.getVetdataLog().then((response) => {
            commit(MAP_VETDATA_LOG, response);
        });
    },
    async [START_VETPOINT_IMPORT]({ dispatch }: any) {
        console.debug(NAME + '::' + START_VETPOINT_IMPORT);

        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        await takeTeilnehmerService.startVetpointImport().then((response) => {
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            dispatch('headerNotification/' + NEW_SUCESS, { text: 'Vetpoint Import erfolreich abgeschlossen' }, { root: true });
            dispatch(GET_VETDATA_LOG);
            dispatch(GET_ARTIKEL, 0);
        });
        dispatch('loadingSpinner/' + HIDE, {}, { root: true });
    },
    async [GET_BENUTZER]({ dispatch, commit, state }: any) {
        console.debug(NAME + '::' + GET_BENUTZER);

        commit(LOADING_BENUTZER, true);
        const searchQuery: BenutzerInfoSearchApiDto = Object.assign({}, state.benutzerFilter);
        await benutzerinfoService
            .getByEmail(searchQuery)
            .then((response) => {
                commit(MAPBENUTZERDATA, response);
            })
            .catch(() => {
                commit(MAPBENUTZERDATA, null);
            })
            .finally(() => {
                commit(LOADING_BENUTZER, false);
            });
    },
    async [LOAD_LIEFERANT_DETAILS]({ dispatch, commit }: any, suchText: string) {
        console.debug(NAME + '::' + LOAD_LIEFERANT_DETAILS);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });

        try {
            const response = await adminUploadService.getLieferantDetails(suchText);
            commit(MAP_LIEFERANT_DETAILS_DATA, response);
        } catch (error: any) {
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            // Lieferant wurde nicht gefunden, Error abfangen
            if (error.response && error.response.status === 404) {
                dispatch('headerNotification/' + NEW_INFO, { text: i18n.global.t('lieferantendokument.findlieferant.lieferantNotFound') }, { root: true });
            } else {
                dispatch('headerNotification/' + NEW_INFO, { text: i18n.global.t('lieferantendokument.findlieferant.unexpectedError') }, { root: true });
            }
            return;
        }
        dispatch('loadingSpinner/' + HIDE, {}, { root: true });
    },

    async [CLEAR_LIEFERANT_DETAILS]({ dispatch, commit, state }: any) {
        console.debug(NAME + '::' + CLEAR_LIEFERANT_DETAILS);
        state.lieferantDetails = null;
    },
    [UPLOAD_DOKUMENT]({ dispatch, commit }: any, dokument: LieferantDokumentUploadDto) {
        console.debug(NAME + '::' + UPLOAD_DOKUMENT);
        // Dokument darf nicht 0 bytes sein.
        if (dokument.datei.size === 0) {
            dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('errormessage.upload.documentsizezero') }, { root: true });
            return;
        }
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });

        adminUploadService.uploadDokument(dokument).then((response) => {
            $router.push({ name: 'AdminLieferantDokumentArchiv', params: {} });
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('upload.erfolgreich') }, { root: true });
        });
    },
    [LOAD_LIEFERANTEN_DOKUMENTE]({ commit, state, dispatch }: any, offset: number) {
        console.debug(NAME + '::' + LOAD_LIEFERANTEN_DOKUMENTE, offset);

        if (state.dokumenteLoading || (offset !== 0 && offset >= state.lieferantenDokumenteTotalNumberOfRecords)) {
            return;
        }

        if (state.lieferantenDokumentFilter.dateFrom != undefined && state.lieferantenDokumentFilter.dateTo != undefined) {
            const dateFrom = new Date(
                state.lieferantenDokumentFilter.dateFrom.substring(6, 10) as any,
                state.lieferantenDokumentFilter.dateFrom.substring(3, 5) as any,
                state.lieferantenDokumentFilter.dateFrom.substring(0, 2) as any
            );
            const dateTo = new Date(
                state.lieferantenDokumentFilter.dateTo.substring(6, 10) as any,
                state.lieferantenDokumentFilter.dateTo.substring(3, 5) as any,
                state.lieferantenDokumentFilter.dateTo.substring(0, 2) as any
            );
            dispatch('headerNotification/' + CLOSE, {}, { root: true });
            if (dateFrom > dateTo) {
                dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('errormessage.impossible.date') }, { root: true });
                return;
            }
        }

        commit(LOADING_DOKUMENTE, true);
        commit(OFFSET_DOKUMENTE, offset);

        const searchQuery = Object.assign({}, state.lieferantenDokumentFilter);
        if (searchQuery.dokumentKategorie === '') {
            searchQuery.dokumentKategorie = null;
        }
        if (searchQuery.teilnehmerId === '') {
            searchQuery.teilnehmerId = null;
        }

        lieferantenDokumentArchivService.getAll(searchQuery).then((response) => {
            if (!offset || offset < 1) {
                commit(TOTAL_NUMBER_OF_RECORDS_LIEFERANTEN_DOKUMENTE, response.totalNumberOfRecords);
                commit(MAP_LIEFERANTEN_DOKUMENTE, response.entries);
            } else {
                commit(ADD_LIEFERANTEN_DOKUMENTE, response.entries);
            }
            commit(LOADING_DOKUMENTE, false);
        });
    },
    [DELETE_DOKUMENT]({ dispatch }: any, id: number) {
        console.debug(NAME + '::' + DELETE_DOKUMENT);

        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        lieferantenDokumentArchivService.deleteDokument(id).then((response) => {
            dispatch(LOAD_LIEFERANTEN_DOKUMENTE, 0);
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
        });
    },
    [OPEN_DOKUMENT]({ commit }: any, { id, dateiTyp, dokumentName }: any) {
        console.debug(NAME + '::' + OPEN_DOKUMENT);

        lieferantenDokumentArchivService.downloadDokument(id).then((response) => {
            downloadService.openOrDownloadFile(response, dokumentName, ['image/jpeg', 'image/png', 'application/pdf']);
        });
    },
    [DOWNLOAD_DOKUMENT]({ commit }: any, { id, dokumentName }: any) {
        console.debug(NAME + '::' + DOWNLOAD_DOKUMENT);

        lieferantenDokumentArchivService.downloadDokument(id).then((response) => {
            downloadService.downloadFile(response, 'placeholder');
        });
    },
    [GET_BENUTZER_DETAILS]({ commit }: any, id: string) {
        console.debug(NAME + '::' + GET_BENUTZER_DETAILS, id);

        return takeTeilnehmerService.getBenutzerDetails(id).then((response) => {
            commit(MAPBENUTZERDETAILS, response, id);
            return response; // Return the response so the caller can use it
        });
    },
    async [GET_ALL_FEHLERHAFTE_RECHNUNGEN_ADMIN]({ commit, state, dispatch }: any, offset: number) {
        console.debug(NAME + '::' + GET_ALL_FEHLERHAFTE_RECHNUNGEN_ADMIN);

        if (state.fehlerhafteRechnungenLoading || (offset !== 0 && offset >= state.fehlerhafteRechnungenTotalNumberOfRecords)) {
            return;
        }

        // Date validation
        if (state.fehlerhafteRechnungenFilter.rechnungDatumVon != undefined && state.fehlerhafteRechnungenFilter.rechnungDatumBis != undefined) {
            const dateFrom = new Date(
                state.fehlerhafteRechnungenFilter.rechnungDatumVon.substring(6, 10) as any,
                state.fehlerhafteRechnungenFilter.rechnungDatumVon.substring(3, 5) as any,
                state.fehlerhafteRechnungenFilter.rechnungDatumVon.substring(0, 2) as any
            );
            const dateTo = new Date(
                state.fehlerhafteRechnungenFilter.rechnungDatumBis.substring(6, 10) as any,
                state.fehlerhafteRechnungenFilter.rechnungDatumBis.substring(3, 5) as any,
                state.fehlerhafteRechnungenFilter.rechnungDatumBis.substring(0, 2) as any
            );
            dispatch('headerNotification/' + CLOSE, {}, { root: true });
            if (dateFrom > dateTo) {
                dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('errormessage.impossible.date') }, { root: true });
                return;
            }
        }

        commit(LOADING_FEHLERHAFTE_RECHNUNGEN_ADMIN, true);
        commit(OFFSET_FEHLERHAFTE_RECHNUNGEN_ADMIN, offset);

        await rechnungService.getAllFehlerhafteRechnungen(state.fehlerhafteRechnungenFilter).then((response) => {
            if (!offset || offset < 1) {
                commit(TOTAL_NUMBER_OF_RECORDS_FEHLERHAFTE_RECHNUNGEN_ADMIN, response.totalNumberOfRecords);
                commit(MAP_FEHLERHAFTE_RECHNUNGEN_ADMIN, response.entries);
            } else {
                commit(ADD_FEHLERHAFTE_RECHNUNGEN_ADMIN, response.entries);
            }
            commit(LOADING_FEHLERHAFTE_RECHNUNGEN_ADMIN, false);
        });
    },
    [DELETE_FEHLERHAFTE_RECHNUNG_ADMIN]({ dispatch, commit }: any, tvsLieferantRechnungId: string) {
        console.debug(NAME + '::' + DELETE_FEHLERHAFTE_RECHNUNG_ADMIN);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        return rechnungService
            .deleteFeherhafteRechnung(tvsLieferantRechnungId)
            .then((response) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN_ADMIN, 0);
                console.debug('deleteRechnung response:', response);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('rechnung.fehlerhaft.delete.erfolgreich') }, { root: true });
                return response;
            })
            .catch((error) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN_ADMIN, 0);
                console.error('deleteRechnung error:', error);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                dispatch(
                    'headerNotification/' + NEW_ERRORMESSAGES,
                    { errorMessages: error.message || i18n.global.t('errormessage.delete.failed') },
                    { root: true }
                );
            });
    },
    [RETRY_RECHNUNG_PROCESSING_ADMIN]({ dispatch, commit }: any, tvsLieferantRechnungId: string) {
        console.debug(NAME + '::' + RETRY_RECHNUNG_PROCESSING_ADMIN);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        return rechnungService
            .retryProcessing(tvsLieferantRechnungId)
            .then((response) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN_ADMIN, 0);
                console.debug('retryProcessing response:', response);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });

                // Check if response is success or error
                if (response.isSuccess === false) {
                    // Translate error codes to messages
                    const errorMessages =
                        response.errors?.map((errorCode: string) => i18n.global.t(errorCode)).join(', ') ||
                        i18n.global.t('errormessage.processing.retry.failed');
                    dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages }, { root: true });
                    return response;
                }
                // Success case
                dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('processing.retry.success') }, { root: true });
                return response;
            })
            .catch((error) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN_ADMIN, 0);
                console.error('retryProcessing error:', error);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                dispatch(
                    'headerNotification/' + NEW_ERRORMESSAGES,
                    { errorMessages: error.message || i18n.global.t('errormessage.processing.retry.failed') },
                    { root: true }
                );
            });
    },
    [UPLOAD_FEHLERHAFTE_RECHNUNG_DATEI_ADMIN]({ dispatch, state }: any, { file, tvsLieferantRechnungId }: { file: File; tvsLieferantRechnungId: string }) {
        console.debug(NAME + '::' + UPLOAD_FEHLERHAFTE_RECHNUNG_DATEI_ADMIN);

        if (file.size === 0) {
            dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('errormessage.upload.documentsizezero') }, { root: true });
            return;
        }

        const validTypes = ['application/pdf', 'text/xml', 'application/xml'];
        if (!validTypes.includes(file.type)) {
            dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('errormessage.upload.invalidfiletype') }, { root: true });
            return;
        }

        dispatch('loadingSpinner/' + SHOW, {}, { root: true });

        rechnungService
            .uploadFehlerhafteRechnungDatei(tvsLieferantRechnungId, file)
            .then((response) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN_ADMIN, 0);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });

                // Check if response is success or error
                if (response.isSuccess === false) {
                    // Translate error codes to messages
                    const errorMessages =
                        response.errors?.map((errorCode: string) => i18n.global.t(errorCode)).join(', ') || i18n.global.t('errormessage.upload.failed'); // ← Fixed
                    dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages }, { root: true });
                    return response;
                }

                // Success case
                dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('upload.erfolgreich') }, { root: true }); // ← Fixed
                return response;
            })
            .catch((error) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN_ADMIN, 0);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                dispatch(
                    'headerNotification/' + NEW_ERRORMESSAGES,
                    { errorMessages: error.message || i18n.global.t('errormessage.upload.failed') },
                    { root: true }
                );
            });
    },
    [DOWNLOAD_BELEG_ADMIN]({ commit }: any, { id, defaultFileName }: any) {
        console.debug(NAME + '::' + DOWNLOAD_BELEG_ADMIN);

        rechnungService.downloadFileAdmin(id).then((response) => {
            downloadService.downloadFile(response, defaultFileName);
        });
    },
    [OPEN_DOKUMENT_ADMIN]({ commit }: any, { id, dateiTyp, dokumentName }: any) {
        console.debug(NAME + '::' + OPEN_DOKUMENT_ADMIN);

        rechnungService.downloadFileAdmin(id).then((response) => {
            downloadService.openOrDownloadFile(response, dokumentName, ['image/jpeg', 'image/png', 'application/pdf']);
        });
    },
    [LOAD_LIEFERANTEN]({ commit }: any) {
        console.debug(NAME + '::' + LOAD_LIEFERANTEN);
        rechnungService.loadLieferanten().then((response) => {
            commit(MAP_LIEFERANTEN_FOR_FILTER, response);
        });
    }
};
